import type * as api from '@gitbook/api-client';
import { confirm, toast } from '@gitbook/spine-react';
import { useEventCallback } from '@gitbook/util-react-hooks';

import { apiClient } from '../../../state';

export interface UseSetDefaultSiteSectionProps {
    organization: api.Organization;
    site: api.Site;
}

export function useSetDefaultSiteSection(props: UseSetDefaultSiteSectionProps) {
    const { site, organization } = props;
    return useEventCallback((siteSection: api.SiteSection) => {
        void confirm({
            title: 'Set section as home?',
            description:
                'Visitors will view this section when they navigate to your site from a search engine or when the type the root URL in the browser.',
            confirmLabel: 'Set as home',
            onConfirm: async (_event, { preventClose }) => {
                await toast.catch(
                    async () => {
                        await apiClient.sites.updateSiteById(organization.id, site.id, {
                            defaultSiteSection: siteSection.id,
                        });
                        toast.success('Home section updated');
                    },
                    'Error while updating home section',
                    { onReject: preventClose }
                );
            },
        });
    });
}
